import classnames from 'classnames';
import React, { FC } from 'react';

import './TrashcanAnimation.scss';

export interface TrashcanAnimationProps {
    className?: string;
    mini?: boolean;
}

const TrashcanAnimation: FC<TrashcanAnimationProps> = ({ className, mini }) => {
    return (
        <svg
            viewBox="0 0 150 170"
            className={classnames('sgw-trashcan-animation', className, { 'trashcan--mini': mini })}
            aria-hidden
        >
            <path
                className="sgw-trashcan-animation__lid"
                d="M124.5,69.7h2.4h2.4c1.1,0,2.2-0.2,3.2-0.6c1-0.4,1.9-1,2.7-1.8c0.8-0.8,1.4-1.7,1.8-2.7c0.4-1,0.6-2.1,0.6-3.2
	c0-1.1-0.2-2.2-0.6-3.2c-0.4-1-1-1.9-1.8-2.7s-1.7-1.4-2.7-1.8c-1-0.4-2.1-0.6-3.2-0.6l0,0l0,0h-16.7H96v-2.1v-2.1
	c0-1.7-0.3-3.3-1-4.8c-0.6-1.5-1.5-2.9-2.7-4.1s-2.6-2.1-4.1-2.7s-3.1-1-4.8-1h-8.3h-8.3c-1.7,0-3.3,0.3-4.8,1S59.2,38.8,58,40
	s-2.1,2.6-2.7,4.1s-1,3.1-1,4.8v2.1V53H37.7H21c-1.1,0-2.2,0.2-3.2,0.6c-1,0.4-1.9,1-2.7,1.8s-1.4,1.7-1.8,2.7
	c-0.4,1-0.6,2.1-0.6,3.2l0,0l0,0c0,1.1,0.2,2.2,0.6,3.2c0.4,1,1,1.9,1.8,2.7c0.8,0.8,1.7,1.4,2.7,1.8c1,0.4,2.1,0.6,3.2,0.6h2.4h2.4
	C126.9,69.7,124.5,69.7,124.5,69.7z M62.7,48.8c0-0.6,0.1-1.1,0.3-1.6c0.2-0.5,0.5-1,0.9-1.4c0.4-0.4,0.9-0.7,1.4-0.9s1-0.3,1.6-0.3
	h8.3h8.3c0.6,0,1.1,0.1,1.6,0.3s1,0.5,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4s0.3,1,0.3,1.6v2.1V53H75.2H62.7v-2.1V48.8z"
            />
            <path
                d="M116.6,153.3c0.5-1.5,0.6-2.9,0.6-2.9l2.3-26.3l4.6-53.9c0,0,0-0.7-0.2-1.1c-0.4-0.5-1.2-0.6-1.2-0.6h-5
	c0,0-0.8,0-1.3,0.4c-0.5,0.4-0.6,1.4-0.6,1.4l-5.6,67.2c0,0-0.4,10.6-2.3,15.5c-1.7,4.5-7,6.5-8,6.8c-0.3,0.1-1.7,0.5-3.7,0.5H54.6
	c0,0-4.8,0.4-9.3-3.4c-4.4-3.7-4.4-8.3-4.4-8.3l-6.7-78.5c0,0,0-0.7-0.5-1.2c-0.4-0.4-1.5-0.5-1.5-0.5h-4.7c0,0-0.9,0-1.3,0.5
	c-0.4,0.5-0.4,1.4-0.4,1.4l6.4,76.7l0.2,3.3c0,0,0.6,4.5,3.2,8.5c1.1,1.6,2.4,3.1,3.9,4.6c2.4,2.4,6.7,4.4,10.4,4.9
	c4.8,0.7,10.9,0.3,11.5,0.3c1.1,0,35.8,0,35.8,0s7-0.4,12.3-5c3.3-2.8,5.4-6,6.5-9.3"
            />
            <path
                d="M54.2,143.7c1.1,0,2.2-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9v-50c0-1.1-0.4-2.2-1.2-2.9
	c-0.8-0.8-1.8-1.2-2.9-1.2c-1.1,0-2.2,0.4-2.9,1.2c-0.8,0.8-1.2,1.8-1.2,2.9v50c0,1.1,0.4,2.2,1.2,2.9
	C52,143.2,53.1,143.7,54.2,143.7z"
            />
            <path
                d="M75,143.7c1.1,0,2.2-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9v-50c0-1.1-0.4-2.2-1.2-2.9c-0.8-0.8-1.8-1.2-2.9-1.2
	s-2.2,0.4-2.9,1.2c-0.8,0.8-1.2,1.8-1.2,2.9v50c0,1.1,0.4,2.2,1.2,2.9C72.8,143.2,73.9,143.7,75,143.7z"
            />
            <path
                d="M95.8,143.7c1.1,0,2.2-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9v-50c0-1.1-0.4-2.2-1.2-2.9
	c-0.8-0.8-1.8-1.2-2.9-1.2c-1.1,0-2.2,0.4-2.9,1.2c-0.8,0.8-1.2,1.8-1.2,2.9v50c0,1.1,0.4,2.2,1.2,2.9
	C93.7,143.2,94.7,143.7,95.8,143.7z"
            />
        </svg>
    );
};

export default TrashcanAnimation;
